export class User {
    public id: number;
    public email: string;
}